/**
 * @file confirm-popup.ts
 * @module app/modules/_common/components/pop-up/confirm-popup
 * @description Utility for displaying a warning confirmation popup.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { showPopup } from './popup-service';
import type { PopupOptions } from './popup-service';

const showConfirmPopup = (options: PopupOptions | string = {}) =>
  showPopup('warning', {
    title: 'Are you sure?',
    message: 'Are you sure you want to continue?',
    showCancelButton: true,
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    focusCancel: true,
    ...(typeof options === 'string' ? { message: options } : options),
  });

export default showConfirmPopup;